import { Plus, Trash2 } from "lucide-react";

const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);

const Line = ({ line, i, options, onChange, onRemove, canRemove }) => (
  <div data-testid={`ibc-quote-line-${i}`} className="grid gap-3 rounded-2xl border border-navy/10 bg-[var(--paper)] p-4 sm:grid-cols-[1.6fr_0.7fr_1fr_auto] sm:items-end">
    <label className="block">
      <span className="mb-2 block text-sm font-semibold text-navy">IBC product <span className="text-brand">*</span></span>
      <select required value={line.product} onChange={(e) => onChange(i, "product", e.target.value)} data-testid={`ibc-quote-line-${i}-product`} className="field">
        <option value="">Select…</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
    <label className="block">
      <span className="mb-2 block text-sm font-semibold text-navy">No. of tanks <span className="text-brand">*</span></span>
      <input required type="number" min="1" max="999" value={line.tanks} onChange={(e) => onChange(i, "tanks", e.target.value)} data-testid={`ibc-quote-line-${i}-tanks`} className="field" />
    </label>
    <label className="block">
      <span className="mb-2 block text-sm font-semibold text-navy">Delivery date <span className="text-brand">*</span></span>
      <input required type="date" min={today()} value={line.date} onChange={(e) => onChange(i, "date", e.target.value)} data-testid={`ibc-quote-line-${i}-date`} className="field" />
    </label>
    <button type="button" onClick={() => onRemove(i)} disabled={!canRemove} aria-label="Remove line" data-testid={`ibc-quote-line-${i}-remove`} className="grid h-[50px] w-full place-items-center rounded-xl border border-navy/15 text-slate-500 transition-colors hover:border-red-300 hover:text-red-600 disabled:opacity-30 sm:w-[50px]">
      <Trash2 className="h-4 w-4" />
    </button>
  </div>
);

export default function QuoteLines({ lines, setLines, options }) {
  const change = (i, k, v) => setLines((ls) => ls.map((l, j) => (j === i ? { ...l, [k]: v } : l)));
  const remove = (i) => setLines((ls) => ls.filter((_, j) => j !== i));
  const add = () => setLines((ls) => [...ls, { product: options[0] ?? "", tanks: "1", date: "" }]);
  return (
    <div className="space-y-3 sm:col-span-2">
      {lines.map((l, i) => (
        <Line key={i} line={l} i={i} options={options} onChange={change} onRemove={remove} canRemove={lines.length > 1} />
      ))}
      {lines.length < 10 && (
        <button type="button" onClick={add} data-testid="ibc-quote-add-line" className="inline-flex items-center gap-2 rounded-full border border-dashed border-brand px-5 py-2.5 text-sm font-semibold text-brand transition-colors hover:bg-brand hover:text-white">
          <Plus className="h-4 w-4" /> Add another tank / delivery
        </button>
      )}
    </div>
  );
}
